module.exports = __webpack_public_path__ + "img/emergency_kit_04.d01eda09.jpg";